<template>
  <v-dialog v-model="dialogOpen" width="550" persistent>
    <v-card>
      <v-card-title>Edit Tariff Details</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-row>
              <v-col>
                <v-select 
                  label="Tariff" v-model="tariff" :items="getWebsiteTariffs" 
                  item-text="name" item-value="id" :disabled="updateProductLoading" 
                  return-object outlined dense hide-details>
                </v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-select 
                  label="Contract Length" v-model="cLength" :items="months" 
                  item-text="name" item-value="months" :disabled="tariff.id===undefined||updateProductLoading" 
                  return-object outlined dense hide-details>
                </v-select>
              </v-col>
              <v-col>
                <v-select 
                  label="Promo" v-model="promo" :items="promos" 
                  item-text="name" item-value="id" :disabled="cLength.months===undefined||updateProductLoading" 
                  return-object outlined dense hide-details>
                </v-select>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col>
                <p><b>Add ons</b></p>
                <template v-for="addon in addons">
                  <v-card :key="addon.id" class="mb-3">
                    <v-card-text>
                      <v-row>
                        <v-col cols="9"><b>{{addon.name}}</b></v-col>
                        <v-col cols="3" class="text-right"><b>{{addon.price | formatCurrency}}</b></v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="4">
                          <v-text-field 
                            label="Quantity" v-model="addon.quantity" :disabled="updateProductLoading" type="number" min="0"
                            @change="calcAddonTotal(addon)" @click="calcAddonTotal(addon)" 
                            outlined dense hide-details>
                          </v-text-field>
                        </v-col>
                        <v-col cols="4" offset="4">
                          <v-text-field label="Total" :value="addon.total" readonly outlined dense hide-details></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </template>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="mb-n8">
          <v-col><p>Exc VAT <b>{{totals.exVat | formatCurrency}}</b></p></v-col>
          <v-col><p class="text-center">VAT <b>{{totals.vat | formatCurrency}}</b></p></v-col>
          <v-col><p class="text-right">Total <b>{{totals.total | formatCurrency}}</b></p></v-col>
        </v-row>

      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="submit" :loading="updateProductLoading" :disabled="updateProductLoading">SAVE</v-btn>
        <v-btn color="primary" small outlined @click="close" :disabled="updateProductLoading">CANCEL</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState,mapActions,mapGetters } from "vuex";
  export default {
    props: ['dialogOpen'],
    data() {
      return {
        tariff: {},
        cLength: {},
        promo: {},
        months: [],
        promos: [],
        addons: [],
      }
    },
    watch: {
      dialogOpen(open){
        if(open){
          this.addons = [];
          this.websiteAddons.forEach(add => {this.addons.push({...add});});
          this.tariff = this.getWebsiteTariffByID;
          this.months = this.tariff.months;
          this.promos = this.tariff.promos;
          if(this.promos!==undefined){
            this.promos.unshift({name: 'No Promo',id:''});
          }

          let m = this.getCurrentProduct.contract_length_months;
          this.cLength = {months:m,name:(m===1)?`Month to month`:`${m} Months`};
          this.promo = this.getWebsitePromoByID;
        }
      },
      tariff(tariff) {
        if(tariff.id!==undefined){
          this.months = tariff.months;
          if(tariff.id!==this.getWebsiteTariffByID.id){
            this.cLength = {};
            this.promo = {};
          }
        }
      },
      cLength(length) {
        if(length.months!==undefined){
          this.promos = this.tariff.promos;
          if(this.promos!==undefined){
            this.promos.unshift({name: 'No Promo',id:''});
          }
          if(this.cLength.months!==this.getCurrentProduct.contract_length_months){
            this.promo = {};
          }
        }
      },
    },
    computed: {
      ...mapState('productWebsite',['websiteAddons','updateProductLoading']),
      ...mapGetters('productWebsite',['getCurrentProduct','getCurrentProductAddons','getWebsiteTariffs','getWebsiteTariffByID','getWebsitePromoByID']),
      totals(){
        let total = (this.promo.price===undefined&&this.tariff.price===undefined)?0:(this.promo.price!==undefined)?parseFloat(this.promo.price):parseFloat(this.tariff.price);
        this.addons.forEach(add => {
          if(add.quantity>0){
            total += add.quantity * parseFloat(add.price);
          }
        });
        let obj ={
          exVat: total,
          vat: total * parseFloat(this.$vatAmount),
          total: total * parseFloat(this.$vatAmount + 1),
        }
        return obj;
      }
    },
    methods: {
      ...mapActions('productWebsite',['updateProduct']),
      calcAddonTotal(addon){
        addon.total = `£${(addon.quantity * parseFloat(addon.price)).toFixed(2)}`;
      },
      async submit() {
        let data = {
          updateData: {
            tariff_id: parseInt(this.tariff.id),
            contract_length_months: parseInt(this.cLength.months),
            promo_id: (this.promo.id!==undefined)?parseInt(this.promo.id):null,
            addons: this.addons.filter(e=>e.quantity>0).map(e=>({addon_id: e.id, quantity: parseInt(e.quantity),})),
          },
          success: 'Tariff details updated successfully!',
        };
        let success = await this.updateProduct(data);
        if(success){ this.close(); }
      },
      close() {
        this.$emit('close-dialog');
      },
    },
  }
</script>

<style lang="scss" scoped></style>
